import React, { useState } from "react";
import products from "../components/allProductsData";
import "../assets/css/AllProducts.css";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";
import { useNavigate } from "react-router-dom";



const AllProductsPage = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);

  const categories = ["All", ...new Set(products.map((item) => item.category))];

  const filteredProducts =
    selectedCategory === "All"
      ? products
      : products.filter((item) => item.category === selectedCategory);

  const itemsPerPage = 6;
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const paginatedData = filteredProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setCurrentPage(1);
  };

  return (
    <>
      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <div className="allproducts-container">
        <h1 className="page-title">Our Products</h1>

        {/* Category Filter */}
        <div className="category-buttons">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`category-btn ${selectedCategory === cat ? "active" : ""}`}
              onClick={() => handleCategoryChange(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Product Grid */}
        <div className="allproducts-grid">
          {paginatedData.map((product) => (
            <div key={product.id} className="allproducts-card">
              <div className="allproducts-image-wrapper">
                <img
                  src={product.image}
                  alt={product.name}
                  className="allproducts-image"
                />

                {/* LOGO */}
                <img
                  src={product.logo}
                  alt="brand"
                  className="allproducts-logo"
                />

                <div className="allproducts-content">
                  <h5>{product.name}</h5>
                  <p>{product.category}</p>
                  <button className="view-button" onClick={() => navigate(product.link)}>View Product</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((page) => page - 1)}
          >
            Prev
          </button>

          <span>
            {currentPage} / {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((page) => page + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </>

  );
};

export default AllProductsPage;
